import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const translateConversationRequest = createAction("".concat(stateName, "/translateConversationNewRequest"));
export const getConversationRequest = createAction("".concat(stateName, "/getConversationRequest"));
export const getShipmentInstructionsRequest = createAction("".concat(stateName, "/getShipmentInstructionsRequest"));
export const getDigitalLabelRequest = createAction("".concat(stateName, "/getDigitalLabelRequest"));